import React, { Component } from 'react'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Icons from '~/Common-Objects/UI/Icons/index'

export default class ComponentSelect extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this)
    }

    change(theVal) {
        this.props.updateVal(this.props.path, theVal)
    }

    render() {
        var style = {}

        if (!this.props.elementData?.allowWhenFullWidth && this.props.localVariables) {
            const hasFullWidth = Object.values(this.props.localVariables).some(
                (lv) => lv.label?.toUpperCase() === 'WIDTH' && lv.value === '100%'
            )

            if (hasFullWidth) {
                return null
            }
        }

        const options = Array.isArray(this.props.options) ? this.props.options : []
        const stacked = !!(
            this.props.elementData &&
            (this.props.elementData.stackedAlign || this.props.elementData.editableTab === 'Columns')
        )
        const tooltipPrefix = (this.props.title || 'align') + '_'

        return (
            <div
                className={
                    'dndEditorv2-dd_toolHolder dndEditorv2-alignItemsTool' +
                    (stacked ? ' dndEditorv2-alignItemsTool--stacked' : '')
                }
                style={style}
            >
                <div className='dndEditorv2-alignItemsRow'>
                    <p className='txtInput_label dndEditorv2-alignItemsLabel'>
                        {this.props.title}
                    </p>
                    <div className='dndEditorv2-inputWrapper'>
                        <div className='dd_alignHolder dndEditorv2-alignHolder'>
                            {options.map((theOpt, index) => {
                                var theType = theOpt.value
                                var theTypeIcon = theOpt.icon
                                if (!theTypeIcon) {
                                    theTypeIcon = theType
                                    switch (theTypeIcon) {
                                        case 'flex-start':
                                        case 'start': {
                                            theTypeIcon = 'top'
                                            break
                                        }
                                        case 'flex-end':
                                        case 'end': {
                                            theTypeIcon = 'bottom'
                                            break
                                        }
                                        case 'center': {
                                            theTypeIcon = 'middle'
                                            break
                                        }
                                        default: {
                                            theTypeIcon = theTypeIcon
                                        }
                                    }
                                    theTypeIcon = 'align' + theTypeIcon.charAt(0).toUpperCase() + theTypeIcon.slice(1)
                                }
                                const tooltip = theOpt.label || theType

                                return (
                                    <ButtonSimple
                                        key={theType + '_' + index}
                                        selected={this.props.value === theType}
                                        onClick={() => {
                                            this.change(theType)
                                        }}
                                        tooltip={tooltip}
                                        toolTipFor={tooltipPrefix + theType}
                                        iconLeft={<Icons icon={theTypeIcon} color='currentColor' />}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
